export const fmtSGD = (v) => {
  if (v == null || v === "") return "—";
  return new Intl.NumberFormat("en-SG", { style: "currency", currency: "SGD", maximumFractionDigits: 0 }).format(v);
};

export const fmtNum = (v, suffix = "") => {
  if (v == null || v === "") return "—";
  return `${new Intl.NumberFormat("en-SG").format(v)}${suffix}`;
};

export const fmtDate = (v) => {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleDateString("en-SG", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return v;
  }
};

export const fmtDateTime = (v) => {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleString("en-SG", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return v;
  }
};

export const WO_STATUSES = [
  "draft", "triaged", "approved", "scheduled", "in_progress", "completed", "verified", "closed",
];

export const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  triaged: "bg-blue-50 text-blue-800 border-blue-200",
  approved: "bg-teal-50 text-teal-800 border-teal-200",
  scheduled: "bg-indigo-50 text-indigo-800 border-indigo-200",
  in_progress: "bg-amber-50 text-amber-900 border-amber-300",
  completed: "bg-emerald-50 text-emerald-800 border-emerald-300",
  verified: "bg-forest-mid text-white border-forest-dark",
  closed: "bg-slate-800 text-slate-100 border-slate-900",
  // evidence pack
  review: "bg-amber-50 text-amber-900 border-amber-300",
  released: "bg-forest-mid text-white border-forest-dark",
  // defects
  open: "bg-rose-50 text-rose-800 border-rose-200",
  resolved: "bg-emerald-50 text-emerald-800 border-emerald-300",
  // interventions
  proposed: "bg-slate-100 text-slate-700 border-slate-200",
  declined: "bg-slate-200 text-slate-600 border-slate-300",
};

export const prettyStatus = (s) => (s || "").replace(/_/g, " ");

export const CATEGORY_STYLES = {
  nature: "bg-emerald-50 text-emerald-800 border-emerald-200",
  people: "bg-blue-50 text-blue-800 border-blue-200",
  business: "bg-amber-50 text-amber-900 border-amber-200",
};

export const SEVERITY_STYLES = {
  low: "bg-slate-100 text-slate-700 border-slate-200",
  medium: "bg-amber-50 text-amber-900 border-amber-200",
  high: "bg-orange-50 text-orange-800 border-orange-300",
  critical: "bg-rose-50 text-rose-800 border-rose-300",
};
